// src/components/PsicomotricidadeInfo.tsx
import React from 'react';
import '../../styles/especialidades.css';

const NeurologistaInfo: React.FC = () => (
    <section className="about_psicomotricidade">
        <div className="teste_zoom_two">
            <div className="about_text_psicomotricidade">
                <h2 className='sub_title'><b>Reconstruindo vínculos, fortalecendo conexões.</b></h2>
                <br />
                <p>A Terapia de Casal é um espaço terapêutico dedicado a promover o diálogo, a compreensão mútua e o fortalecimento da relação entre parceiros. Com escuta ativa e abordagem especializada, o acompanhamento busca acolher os conflitos, resgatar a empatia e desenvolver estratégias para lidar com os desafios da convivência a dois.</p>
                <br />
                <p>Durante as sessões, o casal é estimulado a refletir sobre padrões de comportamento, formas de comunicação, expectativas e sentimentos. O objetivo é promover maior equilíbrio emocional, respeito às individualidades e construção de soluções conjuntas.</p>
                <br />
                <p><b>Quando procurar a terapia de casal?</b></p>
                <br />
                <p>Ela é indicada em situações como:</p>
                <li>Conflitos frequentes ou dificuldade de comunicação;</li>
                <li>Crises de confiança, ciúmes ou traições;</li>
                <li>Distanciamento afetivo, sexual ou emocional;</li>
                <li>Momentos de transição, como nascimento de filhos, mudanças profissionais ou aposentadoria;</li>
                <li>Desejo de fortalecer o vínculo antes do casamento ou após separações temporárias;</li>
                <li>Construção de acordos mais saudáveis na rotina familiar.</li>
                <br />
                <p><b>Benefícios da terapia de casal</b></p>
                <br />
                <p>Investir na relação por meio da terapia proporciona:</p>
                <li>Melhora na comunicação e no entendimento mútuo;</li>
                <li>Redução de conflitos e aumento da cooperação no dia a dia;</li>
                <li>Reaproximação emocional e fortalecimento do vínculo afetivo;</li>
                <li>Ferramentas para lidar com diferenças e tomar decisões em conjunto;</li>
                <li>Promoção de um relacionamento mais saudável, respeitoso e duradouro.</li>
                <br />
                <p><b>Terapia de casal: cuidar da relação é também cuidar de si</b></p>
                <br />
                <p>Mais do que resolver problemas, a terapia de casal é um caminho para redescobrir o parceiro(a) e cultivar uma convivência baseada no afeto, no respeito e na parceria. Cuidar da relação é um ato de coragem, autoconhecimento e amor.</p>
            </div>
        </div>
    </section>
);

export default NeurologistaInfo;